import { FC } from 'react';
import CheckoutErrorMessage from '../../shared/CheckoutErrorMessage';
import styles from './styles/checkoutShippingAndDeliveryError.scss';

const CheckoutShippingAndDeliveryError: FC = () => {
    return (
        <div className={styles.shippingError}>
            <CheckoutErrorMessage errorCode={'SHIPPING_ERROR'} />
        </div>
    );
};

export default CheckoutShippingAndDeliveryError;
